import { render, staticRenderFns } from "./BuilderMain.vue?vue&type=template&id=364b2f29&scoped=true&"
import script from "./BuilderMain.vue?vue&type=script&lang=js&"
export * from "./BuilderMain.vue?vue&type=script&lang=js&"
import style0 from "./BuilderMain.vue?vue&type=style&index=0&id=364b2f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b2f29",
  null
  
)

export default component.exports